import {
  ActionButton,
  BarProgress,
  Button,
  Card,
  cn,
  useHotkeys,
} from "@permutation-city/ui";
import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";

export const Route = createFileRoute("/")({
  component: RouteComponent,
});

const MISSIONS_MOCK = Array(5)
  .fill(null)
  .flatMap(() => [
    {
      title: "Sell $P200 worth of items to the city",
      completed: 100,
      total: 200,
      reward: 10,

      highlight: true,
      completedAt: null,
      type: "daily",
    },
    {
      title: "Farm and harvest 10 corn",
      completed: 10,
      total: 10,
      reward: 20,
      highlight: false,
      completedAt: "2025-03-17",
      type: "ongoing",
    },
    {
      title: "Buy $P100 worth of items from shops",
      completed: 30,
      total: 100,
      reward: 15,
      highlight: false,
      completedAt: null,
      type: "event",
    },
    {
      title: "Sell $P200 worth of items to the city",
      completed: 100,
      total: 200,
      reward: 10,
    },
    {
      title: "Sell $P200 worth of items to the city",
      completed: 100,
      total: 200,
      reward: 10,
    },
    {
      title: "Sell $P200 worth of items to the city",
      completed: 100,
      total: 200,
      reward: 10,
    },
  ]);

function RouteComponent() {
  const [typeSelected, setTypeSelected] = useState<
    "daily" | "ongoing" | "event"
  >();

  useHotkeys("ctrl + D", () => setTypeSelected("daily"));
  useHotkeys("ctrl + O", () => setTypeSelected("ongoing"));
  useHotkeys("ctrl + E", () => setTypeSelected("event"));
  useHotkeys("ctrl + R", () => setTypeSelected(undefined));

  return (
    <div className="grid grid-cols-[minmax(200px,340px)_minmax(400px,1fr)] gap-4 h-full">
      <Card title="CITY HUB" mode="left">
        <img
          src="/profile-pic.png"
          alt="profile"
          className="w-[150px] h-[150px] opacity-70"
        />

        <div className="space-y-4 uppercase">
          <div className="mt-4">
            <h1 className="font-semibold">Zuse</h1>
            <p>
              CITIZEN ID: <span className="font-semibold">101</span>
            </p>
          </div>

          <div className="mt-4">
            <p className="uppercase">
              <span className="font-light">Balance:</span>{" "}
              <span className="font-semibold">1,032,749 $P</span>
            </p>
          </div>

          <div className="mt-4">
            <p className="uppercase">
              Reputation: <span className="font-semibold">LVL 5</span>
            </p>
            <BarProgress progress={50} />
            <p className="text-sm">5,567/10,000 REP</p>
          </div>

          <div className="mt-4">
            <p className="uppercase">
              Plan: <span className="font-semibold">FREE</span>
            </p>
            <BarProgress progress={75} />
            <p className="text-sm">75,000/100,000 MGAS LEFT</p>
          </div>

          <div className="mt-4">
            <Button>Upgrade</Button>
          </div>
        </div>
      </Card>

      <Card title="MISSIONS" mode="left" className="h-full">
        <div className="flex gap-2">
          <ActionButton
            hotkey="^+D"
            onClick={() => setTypeSelected("daily")}
            active={typeSelected === "daily"}
          >
            Daily
          </ActionButton>
          <ActionButton
            hotkey="^+O"
            onClick={() => setTypeSelected("ongoing")}
            active={typeSelected === "ongoing"}
          >
            Ongoing
          </ActionButton>
          <ActionButton
            hotkey="^+E"
            onClick={() => setTypeSelected("event")}
            active={typeSelected === "event"}
          >
            Event
          </ActionButton>
          {typeSelected && (
            <ActionButton
              hotkey="^+R"
              onClick={() => setTypeSelected(undefined)}
            >
              Reset
            </ActionButton>
          )}
        </div>

        <div className="mt-4 flex flex-col gap-4">
          {MISSIONS_MOCK.filter((m) =>
            typeSelected && m.type ? m.type === typeSelected : true,
          ).map((mission, index) => {
            const innerContent = (
              <div className={cn("uppercase flex justify-between gap-4")}>
                <div className="flex flex-col gap-2">
                  <p>{mission.title}</p>
                  <BarProgress
                    progress={Math.round(
                      (mission.completed / mission.total) * 100,
                    )}
                  />
                  <p className="text-sm">
                    {mission.completed}/{mission.total} REP
                  </p>
                </div>

                <div className="flex-shrink-0 flex-col gap-2">
                  <Button isDisabled={Boolean(mission.completedAt)}>
                    Collect {mission.reward} REP
                  </Button>
                </div>
              </div>
            );

            return (
              <Card
                key={index}
                className={cn("h-[120px]", {
                  "opacity-80": mission.completedAt,
                })}
              >
                {innerContent}
              </Card>
            );
          })}
        </div>
      </Card>
    </div>
  );
}
